import { render, staticRenderFns } from "./actStatisDetails.vue?vue&type=template&id=017548b7&scoped=true"
import script from "./actStatisDetails.vue?vue&type=script&lang=js"
export * from "./actStatisDetails.vue?vue&type=script&lang=js"
import style0 from "./actStatisDetails.vue?vue&type=style&index=0&id=017548b7&prod&lang=scss&scoped=true"
import style1 from "./actStatisDetails.vue?vue&type=style&index=1&id=017548b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017548b7",
  null
  
)

export default component.exports